<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-09-28 09:26:48
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 17:32:16
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
  >
    <el-form
      style="margin: 20px 0"
      ref="form"
      size="small"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >
      <el-tabs
        v-model="activeTab"
        type="card"
        size="small"
      >
        <el-tab-pane
          label="描述"
          name="tab-1"
        >

          <el-form-item
            label="选择字段"
            prop="prop"
          >
            <el-select
              v-model="form.prop"
              clearable
              filterable
              allow-create
              default-first-option
              :popper-append-to-body="false"
              placeholder="请选择"
              @change="setFormProp"
            >
              <el-option
                v-for="feild in main.apiFieldList"
                :key="feild.value"
                :label="feild.label"
                :disabled="feild.disabled"
                :value="feild.label"
              ></el-option>
            </el-select>
            <div class="xa-form-tips">备注: 若没有可供选择的字段，可以手动输入！</div>
          </el-form-item>

          <el-form-item label="字号大小">
            <el-input-number
              v-model="form.textFontSize"
              placeholder="请输入"
              style="width: 188px"
            />
          </el-form-item>

          <el-form-item label="字体粗细">
            <el-select
              v-model="form.textFontWeight"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in weightList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="字体颜色">
            <el-color-picker
              v-model="form.textColor"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-form-item>

          <el-form-item label="描述后缀">
            <el-input
              v-model="form.suffixText"
              placeholder="请输入"
              style="width: 188px"
            />
          </el-form-item>

          <el-form-item label="链接地址">
            <el-input
              placeholder="如：http://www.wiseloong.com?id=${id}&name=${name}"
              style="width: 600px"
              v-model="form.url"
            >
            </el-input>
            <div class="xa-form-tips">备注: 输入完整(http://www.xxxx)的地址可以在新窗口中打开！</div>
          </el-form-item>
        </el-tab-pane>

        <el-tab-pane
          label="标题"
          name="tab-2"
        >
          <el-form-item label="标题内容">
            <el-input
              v-model="form.title"
              placeholder="请输入"
              style="width: 300px"
            />
          </el-form-item>

          <el-form-item label="字号大小">
            <el-input-number
              v-model="form.titleFontSize"
              placeholder="请输入"
              style="width: 188px"
            />
          </el-form-item>

          <el-form-item label="字体粗细">
            <el-select
              v-model="form.titleFontWeight"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in weightList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="字体颜色">
            <el-color-picker
              v-model="form.titleColor"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-form-item>

          <el-form-item label="显示Icon">
            <el-switch
              v-model="form.showIcon"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
            />
          </el-form-item>

          <template v-if="form.showIcon">
            <el-form-item label="icon大小">
              <el-input-number
                v-model="form.iconSize"
                placeholder="请输入"
              />
            </el-form-item>

            <el-form-item label="icon圆角">
              <el-input-number
                v-model="form.iconRadius"
                placeholder="请输入"
              />
            </el-form-item>

            <el-form-item label="icon颜色">
              <el-color-picker
                v-model="form.iconColor"
                :predefine="predefineColors"
              />
            </el-form-item>
          </template>
        </el-tab-pane>

        <el-tab-pane
          label="图片"
          name="tab-3"
        >
          <el-form-item label="显示图片">
            <el-switch
              v-model="form.showPicture"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
              @change="setPicture"
            />
          </el-form-item>

          <el-form-item
            label="图片上传"
            v-if="form.showPicture"
          >
            <el-upload
              class="card-picture"
              ref="cardUploader"
              accept="image/*"
              :show-file-list="false"
              :limit="1"
              :http-request="onHttpRequest"
            >
              <img
                class="card-picture-img"
                v-if="form.picture"
                :src="`${FDFS_WEB_SERVER_URL + form.picture}`"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>
        </el-tab-pane>

        <el-tab-pane
          label="背景色"
          name="tab-4"
        >
          <el-form-item label="透明">
            <el-switch
              v-model="form.opcity"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
            />
          </el-form-item>

          <el-form-item label="颜色">
            <el-color-picker
              v-model="form.backgroundColor"
              :predefine="predefineColors"
            />
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer">
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  predefineColors,
  theme,
  component,
  FDFS_WEB_SERVER_URL
} from '@/dragComponents/model/default.js'
import { isEmpty } from '@/dragComponents/utils'
import apiUpload from '@/dragComponents/mixins/apiUpload'

export default {
  name: 'card-field-dialog',
  inject: ['main'],
  mixins: [apiUpload],
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    },
    showType: {
      type: Array
    }
  },
  data() {
    return {
      FDFS_WEB_SERVER_URL: FDFS_WEB_SERVER_URL,
      theme: theme,
      predefineColors: predefineColors,
      form: {},
      activeTab: 'tab-1',
      weightList: component.weightType,
      alignList: component.alignType,
      rules: {
        prop: [{ required: true, message: '请选择字段', trigger: 'blur' }],
        type: [{ required: true, message: '请选择字段类型', trigger: 'blur' }]
      }
    }
  },
  watch: {
    column(val) {
      this.form = val
    },
    form: {
      handler(val) {
        this.$emit('update:column', val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 选择字段
    setFormProp(e) {
      if (isEmpty(e)) return
      let label = isEmpty(e.label) ? e : e.label
      if (isEmpty(e.label)) {
        this.$nextTick(() => {
          this.form.prop = label
        })
      } else {
        this.form.prop = label
      }
    },
    // 上传图片
    onHttpRequest(file) {
      this.apiUploadPicture(file, (path) => {
        this.form.picture = path
        this.$refs.cardUploader.uploadFiles = []
      })
    },
    onSubmit() {
      // 验证
      if (!this.form.prop) {
        this.$message.error('请为描述信息选择字段！')
      }
      this.$refs.form.validate((bool) => {
        if (bool) {
          this.$emit('change', this.form)
          this.dialog.show = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  &-picture {
    width: 100px;
    height: 100px;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;

    &-img {
      width: 100%;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
  }
}
</style>
